import { empty } from './client';

const seg = encodeURIComponent;

/** Delete account (doc 66). */
export const accountApi = {
  deleteOwn: (password: string) => empty('DELETE', '/account', { password }),
  deleteUser: (id: string) => empty('DELETE', `/admin/users/${seg(id)}`),
};
